import React, { useRef, useState } from 'react'
import nnp from './image/avt.jpg'
import vs from './image/VS1.png' 
import ab from './image/google.png'
import { FaUpload } from "react-icons/fa"; // Importing an upload icon (using react-icons library)
import { toast, ToastContainer } from 'react-toastify';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { Api_Url } from './APIUrl';


const RoomJoin = () => {
     const [RoomCode, setRoomcode] = useState();
    const [showUpload, setShowUpload] = useState(false); // Toggle upload section
    const [uploadedFile, setUploadedFile] = useState(null); // Store uploaded file
    const [action, setAction] = useState();

    const location = useLocation();
    const { creatorName, opponentName, entryFee, prize, battleId } = location.state || {};
  
    const battle = location.state?.battle; 

  
  const { prizeplay, creatorNameplay ,BatId, creater,opponent} = location.state || {};


  
  const userName = localStorage.getItem("userName");
    const fileInput = useRef();
    const handleRadioChange = (event) => {
      const selectedValue = event.target.value;
      setAction(selectedValue);
    
      // Show upload only for "I WON"
      if (selectedValue === "won") {
        setShowUpload(true);
      } else {
        setShowUpload(false); // Hide upload for "I LOST" or "CANCEL"
        setUploadedFile(null); // Clear uploaded file
      }
    };
    
    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      setUploadedFile(file);
    };

    const { id } = useParams(); 
// alert(creatorName, opponentName)
    const Roomcode = () =>{

      // alert(BatId)
      // alert(battleId)
      try {
        
        const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
myHeaders.append("Authorization", `Bearer ${localStorage.getItem('token')}`);

const raw = JSON.stringify({
  "battle_id": battleId || BatId,
  "room_code": RoomCode
});

const requestOptions = {
  method: "POST",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};

fetch(`${Api_Url}api/set-roomcode`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    if(result.success === true){
      toast(result?.message)
    }else if (result.message === "Token has expired.") {
      // Token has expired, navigate to the login page
      localStorage.removeItem("token");  // Optionally remove the expired token
      window.location.href = "/";  // Redirect to login page
    }else{ 
if (result?.error) { 
  const errorMessages = Object.values(result.error)
    .flat() 
    .join(' ');  

  // Display the error messages
  toast.error(errorMessages);
}

    }
  })
  .catch((error) => console.error(error));

      } catch (error) {
        
      }
    }



    const SubmitBettleResult = () => {

    //  alert( BatId)
    //  alert( battleId)
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);
    
        const formdata = new FormData();
        formdata.append("battle_id", battleId || BatId,);
        formdata.append("action", action); // Append selected radio value
        if (uploadedFile && action === "won") {
          formdata.append("screenshot", uploadedFile); // Only include file if it's "I WON"
        }
    
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
    
        fetch(`${Api_Url}api/submit-battle-result`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.success) {
              toast.success(result.message); // Display success message
            }else if (result.message === "Token has expired.") {
              // Token has expired, navigate to the login page
              localStorage.removeItem("token");  // Optionally remove the expired token
              window.location.href = "/";  // Redirect to login page
            } else {
                        let errorMessage = result.error;
                        if (errorMessage && typeof errorMessage === "object") {
                          errorMessage = Object.values(errorMessage).flat().join(", ");
                        }
            
                        toast(errorMessage);
                      }
          })
          .catch((error) => {
            console.error("Error:", error);
            toast.error("Error submitting battle result");
          });
      } catch (error) {
        console.error("Error:", error);
        toast.error("Unexpected error occurred");
      }
    };
    





  return (
    <div>
<ToastContainer/>
        <div className='container mt-5 pt-3'>
            <div className='row'>
                <div className='col-lg-12 col-sm-12 m-auto'>
                    <div className='card'>
                        <div className='card-body'>

                        {/* <div> 
      <p>Creator: {battle?.creator_name}</p>
      <p>Opponent: {battle?.opponent_name}</p>
      <p>Entry Fee: {battle?.entry_fee}</p>
      <p>Prize: {battle?.prize}</p>
    </div> */}

                            <div className='row'  style={{verticalAlign:'middle'}}>
                                <div className='col-2'></div>
                                <div className='col-3'>
                                <div>
                                    <h6 style={{fontSize:'15px', textAlign:'center', color:'#959595'}}>
                                    {battle?.creator_name}   {creatorNameplay}</h6>
                                    <div  style={{display:'flex', justifyContent:'center'}}> 
                                    <img src={nnp} style={{width:'50px', borderRadius:'50%'}}/>
                                    </div>
                                    </div>
                                </div>
                                <div className='col-2 mt-3'>
                                <img src={vs} style={{width:'100%', borderRadius:'50%'}}/>  </div>
                                <div className='col-3'>
                                <div>
                                    <h6 style={{fontSize:'15px', textAlign:'center',color:'#959595'}}>
                                    {battle?.opponent_name ? battle.opponent_name : userName}
                                    </h6>
                                    <div  style={{display:'flex', justifyContent:'center'}}> 
                                    <img src={nnp} style={{width:'50px', borderRadius:'50%'}}/>
                                    </div>
                                    </div>
                                </div>

                                <p className='pt-4' style={{fontSize:'15px', fontWeight:'600', textAlign:'center'}}>Playing for 💵 {battle?.prize} {prizeplay} </p>
                            </div>
                          

                        </div>
                    </div>



                    <div className='card mt-4 bg-light border-0'>
                        <div className='card-body '>
                             <h6 className='fs-6 text-center'>Set Room Code</h6>
                             <p  className='fs-6 text-center'>   लूडो किंग से रूम कोड अपलोड करें   </p>

                             <div class="mb-3 mt-4 d-flex justify-content-center"> 
                                <input type="text" class="form-control w-50 " id="exampleInputEmail1" aria-describedby="emailHelp" onChange={(e)=>{setRoomcode(e.target.value)}}     style={{boxShadow:'none', border:'1px solid gray'}}/> 
                                
                            </div>

                               <div  style={{display:'flex', justifyContent:'center'}}>
                            <button className='btn btn-success'  onClick={()=>{Roomcode()}}>SET ROOM CODE</button>
                            </div>
                        </div>  
                    </div>


                    <div className='mt-4'>
                        <p style={{fontSize:'13px', textAlign:'center'}}>Play Ludo game in Ludo King App</p>
                        
                        <div  style={{display:'flex', justifyContent:'center'}}>
                      <NavLink to="https://play.google.com/store/search?q=ludo+king&c=apps&hl=en" target='_blank'> 
                      <img src={ab} style={{width:'100%', height:'80px'}}/> </NavLink>
                    </div>
                    </div>




                              <p className='text-center'>Game Rules</p>
                    <div className='card mt-4  '>
                        <div className='card-header bg-white'>
                        <h6  style={{fontSize:'13px'}}>Record every game while playing.</h6>
                              </div>
                        <div className='card-header bg-white'>
                        <h6 style={{fontSize:'13px'}}>For cancellation of game, video proof is necessary.</h6>
                              </div>
                        <div className='card-header bg-white'>
                        <p style={{color:'red'}}>
                    🔴 <b>महत्वपूर्ण नोट:</b> कृपया गलत गेम परिणाम अपलोड न करें। अन्यथा
                        आपके वॉलेट बैलेंस पर penalty लागू जाएगी। गलत रिजल्ट अपडेट करने पर ₹50
                        पेनल्टी लगेगी।
                  </p>
                              </div>
                        <div className='card-header bg-white'>
                        <p className="mt-2" style={{color:'red'}}>
                        महत्वपूर्ण नोट: यदि आप गेम के परिणामों को अपडेट नहीं करते हैं, तो आपके
                        वॉलेट बैलेंस पर जुर्माना लगाया जाएगा। रिजल्ट अपडेट नहीं करने पर ₹25
                        पेनल्टी लगेगी।
                      </p>
                              </div>
                        
                    </div>


                  <div>

                    <h6 className='mt-4 py-2' style={{backgroundColor:'lightblue', borderRadius:'5px', textAlign:'center'}}>Match Status</h6>


                    <p className='mt-4 fs-6'  style={{color:'#959595'}}>  After completion of your game, select the status of the game and post
                    your screenshot below.</p>
                  </div>


             
                    {/* Radio Button Section */}

                    <div>
  {/* Radio Options */}
  <div
    className="radio-options flex flex-col space-y-3 my-3"
    style={{ display: "flex", justifyContent: "space-around" }}
  >
    {["won", "lost", "cancelled"].map((status) => (
      <label key={status} className="flex items-center fs-6">
        <input
          type="radio"
          name="match_status"
          value={status}
          className="mr-2 me-2"
          onChange={handleRadioChange}
        />
        {status}
      </label>
    ))}
  </div>

  {/* Screenshot Upload Section - Only visible for "I WON" */}
  {showUpload && (
    <div className="file-upload mt-4">
      <label
        htmlFor="file-input"
        className="text-dark"
        style={{
          border: "2px dotted black",
          borderRadius: "10px",
          padding: "15px",
        }}
      >

        <FaUpload className="mr-2 fs-4" /> {/* Upload Icon */}
        Upload Screenshot
      </label>

      {uploadedFile && (
        <div className="mt-2 text-gray-700 text-sm">
          File uploaded: <strong>{uploadedFile.name}</strong>
        </div>
      )}

      
      <input
        id="file-input"
        type="file"
        className="hidden"
        accept="image/*"
        onChange={handleFileUpload}
        style={{ opacity: "0" }}
      />
      
    </div>
  )}

  <button className="btn btn-success m-4" onClick={SubmitBettleResult}>
    SUBMIT
  </button>
</div>


                
                </div>
            </div>
        </div>
    </div>
  )
}

export default RoomJoin




// export default RoomJoin
// import React, { useState } from 'react'
// import nnp from './image/avt.jpg'
// import vs from './image/VS1.png' 
// import ab from './image/google.jpg'
// import { FaUpload } from "react-icons/fa"; // Importing an upload icon (using react-icons library)
// import { toast, ToastContainer } from 'react-toastify';
// import { useParams } from 'react-router-dom';


// const RoomJoin = () => {
//      const [RoomCode, setRoomcode] = useState();
//     const [showUpload, setShowUpload] = useState(false); // Toggle upload section
//     const [uploadedFile, setUploadedFile] = useState(null); // Store uploaded file
  
//     const handleRadioChange = (e) => {
//       const value = e.target.value;
//       if (value === "I WON") {
//         setShowUpload(true); // Show upload section when "I WON" is selected
//       } else {
//         setShowUpload(false); // Hide upload section for other options
//         setUploadedFile(null); // Clear uploaded file when section is hidden
//       }
//     };
  
//     const handleFileUpload = (e) => {
//       const file = e.target.files[0];
//       if (file) {
//         setUploadedFile(file); // Save uploaded file
//       }
//     };


//     const { id } = useParams(); 

//     const Roomcode = () =>{
//       try {
        
//         const myHeaders = new Headers();
// myHeaders.append("Content-Type", "application/json");
// myHeaders.append("Authorization", `Bearer ${localStorage.getItem('token')}`);

// const raw = JSON.stringify({
//   "battle_id": 1,
//   "room_code": RoomCode
// });

// const requestOptions = {
//   method: "POST",
//   headers: myHeaders,
//   body: raw,
//   redirect: "follow"
// };

// fetch("https://brothersludo.in/api/set-roomcode", requestOptions)
//   .then((response) => response.json())
//   .then((result) => {
//     if(result.success == true){
//       toast(result.message)
//     }else{
//       toast(result.message)
//     }
//   })
//   .catch((error) => console.error(error));

//       } catch (error) {
        
//       }
//     }



     





//   return (
//     <div>
// <ToastContainer/>
//         <div className='container mt-5 pt-3'>
//             <div className='row'>
//                 <div className='col-lg-12 col-sm-12 m-auto'>
//                     <div className='card'>
//                         <div className='card-body'>

//                             <div className='row'  style={{verticalAlign:'middle'}}>
//                                 <div className='col-2'></div>
//                                 <div className='col-3'>
//                                 <div>
//                                     <h6 style={{fontSize:'15px', textAlign:'center', color:'#959595'}}>Dev narayan</h6>
//                                     <div  style={{display:'flex', justifyContent:'center'}}> 
//                                     <img src={nnp} style={{width:'50px', borderRadius:'50%'}}/>
//                                     </div>
//                                     </div>
//                                 </div>
//                                 <div className='col-2 mt-3'>
//                                 <img src={vs} style={{width:'100%', borderRadius:'50%'}}/>  </div>
//                                 <div className='col-3'>
//                                 <div>
//                                     <h6 style={{fontSize:'15px', textAlign:'center',color:'#959595'}}>Dev narayan</h6>
//                                     <div  style={{display:'flex', justifyContent:'center'}}> 
//                                     <img src={nnp} style={{width:'50px', borderRadius:'50%'}}/>
//                                     </div>
//                                     </div>
//                                 </div>
//                             </div>
                          

//                         </div>
//                     </div>



//                     <div className='card mt-4 bg-light border-0'>
//                         <div className='card-body '>
//                              <h6 className='fs-6 text-center'>Set Room Code</h6>
//                              <p  className='fs-6 text-center'>   लूडो किंग से रूम कोड अपलोड करें   </p>

//                              <div class="mb-3 mt-4 d-flex justify-content-center"> 
//                                 <input type="text" class="form-control w-50 " id="exampleInputEmail1" aria-describedby="emailHelp" onChange={(e)=>{setRoomcode(e.target.value)}}     style={{boxShadow:'none', border:'1px solid gray'}}/> 
                                
//                             </div>

//                                <div  style={{display:'flex', justifyContent:'center'}}>
//                             <button className='btn btn-success'  onClick={()=>{Roomcode()}}>SET ROOM CODE</button>
//                             </div>
//                         </div>  
//                     </div>


//                     <div className='mt-4'>
//                         <p style={{fontSize:'13px', textAlign:'center'}}>Play Ludo game in Ludo King App</p>
                        
//                         <div  style={{display:'flex', justifyContent:'center'}}>
//                         <img src={ab} style={{width:'80%'}}/>
//                     </div>
//                     </div>




//                               <p className='text-center'>Game Rules</p>
//                     <div className='card mt-4  '>
//                         <div className='card-header bg-white'>
//                         <h6  style={{fontSize:'13px'}}>Record every game while playing.</h6>
//                               </div>
//                         <div className='card-header bg-white'>
//                         <h6 style={{fontSize:'13px'}}>For cancellation of game, video proof is necessary.</h6>
//                               </div>
//                         <div className='card-header bg-white'>
//                         <p style={{color:'red'}}>
//             🔴 <b>महत्वपूर्ण नोट:</b> कृपया गलत गेम परिणाम अपलोड न करें। अन्यथा
//             आपके वॉलेट बैलेंस पर penalty लागू जाएगी। गलत रिजल्ट अपडेट करने पर ₹50
//             पेनल्टी लगेगी।
//           </p>
//                               </div>
//                         <div className='card-header bg-white'>
//                         <p className="mt-2" style={{color:'red'}}>
//             महत्वपूर्ण नोट: यदि आप गेम के परिणामों को अपडेट नहीं करते हैं, तो आपके
//             वॉलेट बैलेंस पर जुर्माना लगाया जाएगा। रिजल्ट अपडेट नहीं करने पर ₹25
//             पेनल्टी लगेगी।
//           </p>
//                               </div>
                        
//                     </div>


//                   <div>

//                     <h6 className='mt-4 py-2' style={{backgroundColor:'lightblue', borderRadius:'5px', textAlign:'center'}}>Match Status</h6>


//                     <p className='mt-4 fs-6'  style={{color:'#959595'}}>  After completion of your game, select the status of the game and post
//                     your screenshot below.</p>
//                   </div>


             
//                     {/* Radio Button Section */}
//       <div className="radio-options flex flex-col space-y-3 my-3" style={{display:'flex', justifyContent:'space-around'}}>
//         <label className="flex items-center fs-6">
//           <input
//             type="radio"
//             name="match_status"
//             value="I WON"
//             className="mr-2 me-2"
//             onChange={handleRadioChange}
//           />
//           I WON
//         </label>
//         <label className="flex items-center fs-6">
//           <input
//             type="radio"
//             name="match_status"
//             value="I LOST"
//             className="mr-2 me-2"
//             onChange={handleRadioChange}
//           />
//           I LOST
//         </label>
//         <label className="flex items-center fs-6">
//           <input
//             type="radio"
//             name="match_status"
//             value="CANCEL"
//             className="mr-2 me-2"
//             onChange={handleRadioChange}
//           />
//           CANCEL
//         </label>
//       </div>

//       {/* Image Upload Section */}
//       {showUpload && (
//         <div className="file-upload mt-4">
//           <label
//             htmlFor="file-input"
//             className=" text-dark"

//             style={{ border: "2px dotted black", borderRadius:'10px', padding:'15px'}}
//           >
//             <FaUpload className="mr-2 fs-4" /> {/* Upload Icon */}
//             Upload Screenshot
//           </label>
//           <input
//             id="file-input"
//             type="file"
//             className="hidden"
//             accept="image/*"
//             onChange={handleFileUpload}
//             style={{opacity:'0'}} // Handle file upload
//           />

//           {/* Show Uploaded File Name */}
//           {uploadedFile && (
//             <div className="mt-2 text-gray-700 text-sm">
//               File uploaded: <strong>{uploadedFile.name}</strong>
//             </div>
//           )}
//         </div>
//       )}

//                   <button className='btn btn-success m-4' > SUBMIT</button>



//                 </div>
//             </div>
//         </div>
//     </div>
//   )
// }

// export default RoomJoin